import FormField, {
  FormFieldSelectProps,
} from 'components/form-field/form-field';
import { OrderBy, useSelectTradeGroupFieldQuery } from 'generated/graphql';
import React, { FunctionComponent, useMemo } from 'react';
import { DropdownItemProps } from 'semantic-ui-react';

type SelectTradeGroupFieldProps = Omit<
  FormFieldSelectProps,
  'options' | 'type' | 'loading' | 'disabled'
>;

const SelectTradeGroupField: FunctionComponent<SelectTradeGroupFieldProps> = ({
  multiple,
  ...rest
}) => {
  const { data, loading, error } = useSelectTradeGroupFieldQuery({
    fetchPolicy: 'no-cache',
    variables: {
      order_by: [{ name: OrderBy.Asc }],
    },
  });

  const options: DropdownItemProps[] = useMemo(() => {
    if (data?.tradeGroup) {
      return data.tradeGroup.map((tradeGroup) => ({
        key: tradeGroup.id,
        value: tradeGroup.id,
        text: tradeGroup.name,
      }));
    }
    return [];
  }, [data?.tradeGroup]);

  const placeholder = useMemo(() => {
    if (loading) {
      return 'Chargement des univers...';
    }
    if (multiple) {
      return 'Selectionnez des univers...';
    }
    return 'Selectionnez un univers...';
  }, [loading, multiple]);

  if (error) return <>Error! {error.message}</>;

  return (
    <FormField
      type="select"
      loading={loading}
      disabled={loading}
      options={options}
      multiple={multiple}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default SelectTradeGroupField;
